'use client';

export function SkeletonCard() {
  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-coral-100">
      <div className="flex gap-3">
        <div className="w-20 h-20 rounded-xl skeleton-wave flex-shrink-0" />
        <div className="flex-1 space-y-2.5 py-1">
          <div className="h-4 skeleton-wave rounded-md w-3/4" />
          <div className="h-3 skeleton-wave rounded-md w-1/2" />
          <div className="h-3 skeleton-wave rounded-md w-2/5" />
          <div className="h-3 skeleton-wave rounded-md w-4/5" />
          <div className="flex gap-2">
            <div className="h-3 skeleton-wave rounded-md w-1/4" />
            <div className="h-3 skeleton-wave rounded-md w-1/4" />
          </div>
        </div>
      </div>
    </div>
  );
}
